import type {UserV2} from './UserV2';

export type TemplateV2 = {
  id: string;
  title: string;
  note: string | null;
  primary: boolean;
  system: boolean;
  hidden: boolean;
  url: string;
  fileName: string;
  documentKindCode: string;
  updatedAt: string | null;
  updatedBy: UserV2;
};
